import {
  all,
  put,
  takeEvery,
  fork
} from 'redux-saga/effects';
import actions from './actions';
import {
  post,
} from '@iso/lib/helpers/resApiRequestor';

export function* fetchStatus() {
  yield takeEvery('FETCH_STATUS_COUNT', function* (payload) {

    try {
      yield put({
        type: actions.FETCHING_STATUS,
      });
      const apiResult = yield fetchStatusURI(payload.payload);
      const result = apiResult.data;

      if (result.success === true) {
        yield put({
          type: actions.FETCHED_STATUS,
          payload: result.data.result,
        });
      }
    } catch (error) {
      yield put({
        type: actions.FETCH_STATUS_ERROR,
        payload: error,
      });
    }
  });
}

function fetchStatusURI(payload) {
  const finalData = {
    mids: payload.mids,
    pchannelId: payload.pchannelId
  };
  return post(`counters/status`, finalData);
}

export default function* rootSaga() {
  yield all([
    fork(fetchStatus),
  ]);
}
